import React from 'react';

const TagItem = ({ name, color, apiUrl, id, onClick }) => {
  const getColorClass = () => {
    switch(color) {
      case 'Синий': return 'blueTag';
      case 'Желтый': return 'yellowTag';
      case 'Красный': return 'redTag';
      default: return 'blueTag';
    }
  };

  return (
    <div 
      className={`tagItem ${getColorClass()} flex-row`} 
      onClick={() => onClick(apiUrl, id)}
      style={{ cursor: 'pointer' }}
    >
      <p className="tagItemName">{name}</p>
    </div>
  );
};

export default TagItem;